var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 120,
    viewBox: "0 0 216 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_72402)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.84
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.25 19.6459C193.439 19.6459 196.834 23.041 196.834 27.2292C196.834 31.4174 193.439 34.8125 189.25 34.8125H145.917C150.105 34.8125 153.5 38.2077 153.5 42.3959C153.5 46.584 150.105 49.9792 145.917 49.9792H169.75C173.939 49.9792 177.334 53.3744 177.334 57.5625C177.334 61.7507 173.939 65.1459 169.75 65.1459H158.729C153.448 65.1459 149.167 68.5411 149.167 72.7292C149.167 74.6853 150.23 76.5116 152.357 78.2082C154.374 79.8169 157.181 80.0266 159.421 81.3056C161.709 82.6114 163.25 85.0736 163.25 87.8959C163.25 92.084 159.855 95.4792 155.667 95.4792H65.7503C61.5622 95.4792 58.167 92.084 58.167 87.8959C58.167 83.7077 61.5622 80.3125 65.7503 80.3125H23.5003C19.3122 80.3125 15.917 76.9174 15.917 72.7292C15.917 68.5411 19.3122 65.1459 23.5003 65.1459H66.8337C71.0218 65.1459 74.417 61.7507 74.417 57.5625C74.417 53.3744 71.0218 49.9792 66.8337 49.9792H39.7503C35.5622 49.9792 32.167 46.584 32.167 42.3959C32.167 38.2077 35.5622 34.8125 39.7503 34.8125H83.0837C78.8955 34.8125 75.5003 31.4174 75.5003 27.2292C75.5003 23.041 78.8955 19.6459 83.0837 19.6459H189.25ZM189.25 49.9792C193.439 49.9792 196.834 53.3744 196.834 57.5625C196.834 61.7507 193.439 65.1459 189.25 65.1459C185.062 65.1459 181.667 61.7507 181.667 57.5625C181.667 53.3744 185.062 49.9792 189.25 49.9792Z",
    fill: "#E7E6ED",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.561 19.6461L142.638 93.1424L143.543 100.516C143.835 102.891 142.146 105.053 139.77 105.345L76.33 113.134C73.9546 113.426 71.7925 111.737 71.5009 109.362L61.7338 29.8151C61.5879 28.6274 62.4325 27.5463 63.6202 27.4005C63.6277 27.3996 63.6353 27.3987 63.6428 27.3977L68.906 26.8075L132.561 19.6461ZM73.1619 26.3301L78.1312 25.7726L73.1619 26.3301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1619 26.3301L78.1312 25.7726M132.561 19.6461L142.638 93.1424L143.543 100.516C143.835 102.891 142.146 105.053 139.77 105.345L76.33 113.134C73.9546 113.426 71.7925 111.737 71.5009 109.362L61.7338 29.8151C61.5879 28.6274 62.4325 27.5463 63.6202 27.4005C63.6277 27.3996 63.6353 27.3987 63.6428 27.3977L68.906 26.8075L132.561 19.6461Z",
    stroke: "#B8B8B8",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.818 24.2706L138.94 90.878L139.76 97.5603C140.024 99.713 138.514 101.67 136.387 101.931L79.5749 108.907C77.4476 109.168 75.5089 107.634 75.2446 105.482L66.4154 33.5739C66.2696 32.3862 67.1142 31.3051 68.3019 31.1593L75.3301 30.2963",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.331 5.83337H85.9782C85.1555 5.83337 84.4107 6.16683 83.8716 6.70595C83.3325 7.24508 82.999 7.98987 82.999 8.81254V91.1459C82.999 91.9685 83.3325 92.7133 83.8716 93.2525C84.4107 93.7916 85.1555 94.125 85.9782 94.125H149.895C150.718 94.125 151.462 93.7916 152.001 93.2525C152.541 92.7133 152.874 91.9685 152.874 91.1459V23.367C152.874 22.5766 152.56 21.8186 152.001 21.2598L137.437 6.7053C136.879 6.147 136.121 5.83337 135.331 5.83337Z",
    fill: "white",
    stroke: "#B8B8B8",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.812 7.08228V19.6459C135.812 21.4408 137.267 22.8959 139.062 22.8959H147.656",
    stroke: "#B8B8B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6445 78.1459H122.811M94.6445 22.8959H122.811H94.6445ZM94.6445 35.8959H141.228H94.6445ZM94.6445 49.9792H141.228H94.6445ZM94.6445 64.0625H141.228H94.6445Z",
    stroke: "#B8B8B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_72402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivity);
export default __webpack_public_path__ + "static/media/no_activity.a864b303cda2757321439ec3688e5c6b.svg";
export { ForwardRef as ReactComponent };